import { ANALYTIC_EVENTS } from 'analytics/Analytics';

type FormValidateAnalyticEventsType = {
  [key: string]: {
    success: string;
    error: string;
  };
};

const formValidateAnalyticEvents: FormValidateAnalyticEventsType = {
  pan: {
    success: ANALYTIC_EVENTS.panSuccess,
    error: ANALYTIC_EVENTS.panError,
  },
  validity: {
    success: ANALYTIC_EVENTS.validitySuccess,
    error: ANALYTIC_EVENTS.validityError,
  },
  cvv: {
    success: ANALYTIC_EVENTS.cvvSuccess,
    error: ANALYTIC_EVENTS.cvvError,
  },
};

export { formValidateAnalyticEvents };
